module.exports = __webpack_public_path__ + "img/38_70.65309901.png";